/* unplugin-vue-components disabled */import { render } from "./zhejiangmap.vue?vue&type=template&id=01d30036&scoped=true"
import script from "./zhejiangmap.vue?vue&type=script&lang=js"
export * from "./zhejiangmap.vue?vue&type=script&lang=js"

import "./zhejiangmap.vue?vue&type=style&index=0&id=01d30036&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d30036"]])

export default __exports__